import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/plugin/isoWeek'
import isoWeek from 'dayjs/plugin/isoWeek'
import { Col, Row } from 'react-bootstrap'
import { Select } from 'antd'
import { Dispatch, SetStateAction, useState } from 'react'
import { isMobile } from 'react-device-detect';

dayjs.extend(isoWeek) 

export const MonthPickerComponent : React.FC<{
    pickedDate : Dayjs
    setPickedDate : Dispatch<SetStateAction<Dayjs>>,
    setIsLoaded : Dispatch<SetStateAction<boolean>>,
    setMonthSwitcher : Dispatch<SetStateAction<boolean>>,
    isParent : boolean
}> = (props) => {

    const {pickedDate, setPickedDate, setIsLoaded, setMonthSwitcher, isParent} = props
    const [currentDate] = useState<Dayjs>(dayjs())
    
    const handleMonthChange = (value : string) => {
        let tempDate : Dayjs
        switch (value) {
            case "one-month-behind":
                tempDate = currentDate.add(-1,'month').set('date',1)
            break
            case "one-month-forward":
                tempDate = currentDate.add(1,'month').set('date',1)
            break
            default: 
                tempDate = currentDate
        }
        setPickedDate(tempDate)
        setMonthSwitcher(prev => !prev)
        setIsLoaded(false)
    }

    const handleMonthList = () : ({ label: string; value: string })[] => {
        var list = [
            { value: "one-month-forward", label: currentDate.add(1,'month').format('MMMM YYYY').toLocaleUpperCase() },
            { value: "current-month", label: currentDate.format('MMMM YYYY').toLocaleUpperCase()}
        ]
        if (!isParent) {
            list.push({ value: "one-month-behind", label: currentDate.add(-1,'month').format('MMMM YYYY').toLocaleUpperCase()})
        }

        return list
    }

    return (
        <>
        {isMobile ?
        <Select
        defaultValue={pickedDate.format('MMMM YYYY').toLocaleUpperCase()}
        style={{ width: '100%', textDecorationColor: 'ffffff', padding: '0'}}
        size='small'
        onChange={(e)=> {handleMonthChange(e)}}
        options={handleMonthList()}
        />
        :
        <Col>
          <Row className={'customRow'} 
            style={{ alignItems: "center" }}
            align={'middle'} 
            type="flex"
            justify="center"
            gutter={10}>
            <Col>Wybrany miesiąc:</Col>
            <Col>
                <Select
                    defaultValue={pickedDate.format('MMMM YYYY').toLocaleUpperCase()}
                    style={{ width: '100%', textDecorationColor: 'ffffff'}}
                    size={isMobile ? 'small' : 'middle'}
                    onChange={(e)=> {handleMonthChange(e)}}
                    options={handleMonthList()}
                />
            </Col>
          </Row>
        </Col>
        }
        </>
        

    )
}